
/// 新闻列表
export const NewsUrl = 'https://str.shenmacredit.com.my/api/news'

/// 新闻详情
export const NewsDetailUrl = 'https://str.shenmacredit.com.my/api/news/'

/// 首页广告
export const HomeADUrl = 'https://str.shenmacredit.com.my/api/pop-ups'

/// 首页广告详情
export const HomeADDetailUrl = 'https://str.shenmacredit.com.my/api/pop-ups/'

/// ourDear列表
export const OurDearUrl = 'https://str.shenmacredit.com.my/api/our-dears'

/// our dealer页面 state 下拉框数据
export const OurDearStateUrl = 'https://str.shenmacredit.com.my/api/state-lists'

/// 上传文件
export const UploadUrl = 'https://str.shenmacredit.com.my/api/upload'

/// contact us提交
export const ContactUsSubmitUrl = 'https://str.shenmacredit.com.my/api/contact-uses'

/// FAQ
export const FAQUrl = 'https://str.shenmacredit.com.my/api/faqs'

/// Find Your Bank-In Account
export const FindBankUrl = 'https://e-shenma.com.my/customer/va/new/checkAgreement'

/// One click pay
export const OneClickPayUrl = 'https://e-shenma.com.my/customer/va/new/checkAgreement'

/// product-image
export const ProductImageUrl = 'https://str.shenmacredit.com.my/api/webtitles/1'


/// video list
export const VideoListUrl = 'https://str.shenmacredit.com.my/api/videos'
